export enum EEtsyFormTypes {
  DETAILS = 'details',
  PRICE = 'price',
  IMAGES = 'images'
}
